import './ButtonScreen.vars.css'

const responsiveStyles = {
  bottom: 'var(--button-screen-bottom)',
  right: 'var(--button-screen-right)',
  zIndex: 3
}

export default responsiveStyles
